document.addEventListener("DOMContentLoaded", function () {
  const popup        = document.getElementById("gift-popup");
  const popupInner   = popup ? popup.querySelector(".gift-popup-inner") : null;
  const closeBtn     = document.querySelector(".gift-popup-close");
  const minibar      = document.querySelector(".gift-minibar");
  const minibarToggle= document.querySelector(".gift-minibar-toggle");
  const cartBar      = document.querySelector("#cart-bar");

  let isAnimating   = false;
  let dismissedOnce = false;
  let lastCartKey   = "";
  let scrollY       = 0;

  /* ---------- Scroll-Lock ---------- */
  function lockScroll() {
    document.documentElement.classList.add("gift-popup-open");
    document.body.classList.add("gift-popup-open");
  }
  function unlockScroll() {
    document.documentElement.classList.remove("gift-popup-open");
    document.body.classList.remove("gift-popup-open");
  }

  /* ---------- Minibar ---------- */
  function showMinibar() {
    if (minibar && !popup.classList.contains("active")) {
      minibar.style.display = "flex";
      adjustCartBar();
    }
  }
  function hideMinibar() {
    if (minibar) minibar.style.display = "none";
    resetCartBar();
  }

  /* ---------- Popup ---------- */
  function openGiftPopup(force = false) {
    if (!popup || isAnimating) return;
    if (popup.classList.contains("active")) return;

    if (dismissedOnce && !force) return; // nur einmal pro Session

    isAnimating = true;
    hideMinibar();
    lockScroll();

    popup.style.display = "block";
    requestAnimationFrame(() => {
      popup.classList.add("active");
      setTimeout(() => { isAnimating = false; }, 60);
    });
  }

  function closeGiftPopup() {
    if (!popup || isAnimating) return;
    isAnimating = true;
    dismissedOnce = true;
    sessionStorage.setItem("giftPopupDismissed", "true");

    popup.classList.add("closing"); // Animation starten

    setTimeout(() => {
      popup.classList.remove("active");
      popup.classList.remove("closing");
      popup.style.display = "none";
      unlockScroll();
      isAnimating = false;
    }, 350);
  }

  function minimizeToMinibar() {
    if (!popup || isAnimating) return;
    isAnimating = true;
    dismissedOnce = true;
    sessionStorage.setItem("giftPopupDismissed", "true");

    popup.classList.add("closing"); // Animation starten

    setTimeout(() => {
      popup.classList.remove("active");
      popup.classList.remove("closing");
      popup.style.display = "none";
      unlockScroll();
      showMinibar(); // Minibar erst NACH dem Schließen
      isAnimating = false;
    }, 350);
  }

  function restoreFromMinibar() {
    dismissedOnce = false;
    hideMinibar();
    openGiftPopup(true);
  }

  /* ---------- Events ---------- */
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      minimizeToMinibar();
    });
  }
  if (minibarToggle) {
    minibarToggle.addEventListener("click", (e) => {
      e.preventDefault();
      restoreFromMinibar();
    });
  }
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "gift-popup") {
      e.preventDefault();
      closeGiftPopup();
    }
  });

  /* ---------- Bedingung prüfen ---------- */
  const POPUP_DELAY_MS = 900;

  function checkGiftCondition() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        let hasKette   = false;
        let hasBrosche = false;
        let qtyKette   = 0;
        let qtyBrosche = 0;

        (cart.items || []).forEach((item) => {
          const h = (item.handle || "").toLowerCase();
          if (h.includes("kette")) {
            hasKette = true;
            qtyKette += item.quantity;
          }
          if (h.includes("bonding-brosche") || h.includes("brosche")) {
            hasBrosche = true;
            qtyBrosche += item.quantity;
          }
        });

        const conditionMet = hasKette && hasBrosche;
        const cartKey = (cart.items || []).map(i => (i.key || i.id) + ":" + i.quantity).join("|");

        // Texte anpassen
        const popupText   = document.getElementById("gift-popup-text");
        const minibarText = document.getElementById("gift-minibar-text");

        if (qtyKette >= 2 && qtyBrosche >= 2) {
          if (popupText)   popupText.textContent   = "Ihr bekommt beide Geschenke gratis zu eurer Bestellung dazu. Bitte wählt eure Lieblingsfarben:";
          if (minibarText) minibarText.textContent = "Wähle die Farben deiner Geschenke aus:";
        } else if (conditionMet) {
          if (popupText)   popupText.textContent   = "Wähle dein Gratisgeschenk aus:";
          if (minibarText) minibarText.textContent = "Wähle dein Gratisgeschenk aus:";
        } else {
          if (popupText)   popupText.textContent   = "Wähle dein Gratisgeschenk aus:";
          if (minibarText) minibarText.textContent = "Wähle dein Gratisgeschenk aus:";
        }

        const alreadyDismissed = sessionStorage.getItem("giftPopupDismissed") === "true";

        if (conditionMet && cartKey !== lastCartKey && !alreadyDismissed) {
          lastCartKey = cartKey;
          setTimeout(() => openGiftPopup(), POPUP_DELAY_MS);
        } else if (conditionMet) {
          showMinibar();
        } else {
          hideMinibar();
          if (popup) {
            popup.style.display = "none";
            popup.classList.remove("active");
            unlockScroll();
          }
        }
      })
      .catch(() => {});
  }

  // Initial
  checkGiftCondition();

  // Events
  document.body.addEventListener("click", function (e) {
    if (e.target && (e.target.type === "submit" || e.target.name === "add")) {
      setTimeout(checkGiftCondition, 800);
    }
  });
  const kick = () => setTimeout(checkGiftCondition, 600);
  document.addEventListener("theme:cart:add",     () => setTimeout(checkGiftCondition, 800));
  document.addEventListener("theme:cart:change",  kick);
  document.addEventListener("theme:cart:updated", kick);
  document.addEventListener("cart:updated",       kick);

  /* ---------- Swipe ---------- */
  document.querySelectorAll(".gift-image-wrapper").forEach((wrapper) => {
    const images = wrapper.querySelectorAll("img");
    let currentIndex = 0;

    function showImage(index) {
      images.forEach((img, i) => {
        img.style.transform = `translateX(${(i - index) * 100}%)`;
      });
      const indicator = wrapper.querySelector(".gift-swipe-indicator");
      if (indicator) indicator.style.left = index === 0 ? "0" : "50%";
      currentIndex = index;
    }

    showImage(0);
    wrapper.addEventListener("click", () => showImage(currentIndex === 0 ? 1 : 0));
    wrapper.addEventListener("touchstart", () => showImage(currentIndex === 0 ? 1 : 0), { passive: true });
  });
  /* ---------- Cart-Bar Anpassung ---------- */
  function adjustCartBar() {
    if (cartBar && minibar) {
      const minibarVisible = window.getComputedStyle(minibar).display !== "none" && minibar.offsetHeight > 0;
      if (minibarVisible) {
        cartBar.style.bottom = minibar.offsetHeight + "px";
      } else {
        cartBar.style.bottom = "0px";
      }
    }
  }
  function resetCartBar() {
    if (cartBar) cartBar.style.bottom = "0px";
  }

  // 👉 NEU: Synchronisierung bei Scroll/Resize
  window.addEventListener("scroll", adjustCartBar);
  window.addEventListener("resize", adjustCartBar);
});

// === Tap-vs-Swipe Fix mit Info-Popup Trigger ===
document.querySelectorAll('.gift-item-link .gift-image-wrapper').forEach(wrapper => {
  let startX = 0;
  let startY = 0;
  let moved = false;
  let touchStartTime = 0;

  wrapper.addEventListener('touchstart', (e) => {
    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    touchStartTime = Date.now();
    moved = false;
  }, { passive: true });

  wrapper.addEventListener('touchmove', (e) => {
    const touch = e.touches[0];
    const dx = Math.abs(touch.clientX - startX);
    const dy = Math.abs(touch.clientY - startY);
    if (dx > 8 || dy > 8) moved = true; // → Swipe erkannt
  }, { passive: true });

  wrapper.addEventListener('touchend', (e) => {
    const touchDuration = Date.now() - touchStartTime;
    // Nur kurzer Tap → Klick simulieren
    if (!moved && touchDuration < 300) {
      e.preventDefault();
      e.stopPropagation();

      const link = wrapper.closest('a.gift-item-link');
      if (link) {
        // 🔥 Upsell-Trigger wie beim Klick aktivieren
        localStorage.setItem('dackl_upsell_trigger', 'true');

        // Direkt weiterleiten zum Produkt
        window.location.assign(link.href);
      }
    }
  });
});